var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notifications"},[_c('v-container',[_c('v-layout',[_c('v-tabs',[_c('v-tab',{staticClass:"text-none",attrs:{"to":"/notifications"}},[_vm._v("Push Notifications ")])],1)],1),_c('v-divider'),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }